import type { DrawerViewProps } from '@app/src/components/Drawer/DrawerView'
import DrawerView from '@app/src/components/Drawer/DrawerView'
import { findTopicRisk } from '@app/src/pages/TopicalRisk/CompanyPage/providerRiskSnapshot.logic'
import { useProviderRiskSnapshot } from '@app/src/pages/TopicalRisk/CompanyPage/useProviderRiskSnapshot'
import { TopicalRiskDrawerBody } from '@app/src/pages/TopicalRisk/Drawer/TopicalRiskDrawerBody'
import type { SustainabilityTopicRisk } from '@app/src/types/topicalRisk'
import React from 'react'

export type DrawerViewTopicalRiskProps = {
  sustainabilityTopicRisk: SustainabilityTopicRisk
} & DrawerViewProps

const DrawerViewTopicalRisk: React.FC<DrawerViewTopicalRiskProps> = ({ sustainabilityTopicRisk, ...props }) => {
  // The drawer is opened with the topic risk captured in a closure, so it would otherwise keep
  // showing the snapshot that was current at click time. Re-read it from the shared query so a
  // recalculation that lands while the drawer is open is reflected here too.
  const { currentProviderRisk } = useProviderRiskSnapshot(sustainabilityTopicRisk.providerId)
  const latestTopicRisk =
    findTopicRisk(currentProviderRisk, sustainabilityTopicRisk.sustainabilityTopic?.id) ?? sustainabilityTopicRisk

  return (
    <DrawerView {...props}>
      <TopicalRiskDrawerBody sustainabilityTopicRisk={latestTopicRisk} />
    </DrawerView>
  )
}

export default DrawerViewTopicalRisk
